(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    const requireVatNumber = () => {
    const inputs = document.querySelectorAll('input[name="attributes[tax-number]"]');

    for (const input of inputs) {
      input.required = true;
      input.setAttribute('aria-required', 'true');
      input.setAttribute('form', 'cart-form');
    }
  };

  requireVatNumber();

  const vatNumberObserver = new MutationObserver(requireVatNumber);
  vatNumberObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    const initializeVideoSoundControls = (root = document) => {
    root.querySelectorAll('[data-video-sound-control]:not([data-sound-control-ready])').forEach((button) => {
      button.dataset.soundControlReady = 'true';
      button.addEventListener('click', async () => {
        const video = button.closest('deferred-media')?.querySelector('video');
        if (!video) return;

        video.muted = false;
        video.volume = 1;

        try {
          await video.play();
          button.classList.add('is-hidden');
        } catch (error) {
          video.muted = true;
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeVideoSoundControls(), { once: true });
  } else {
    initializeVideoSoundControls();
  }

  document.addEventListener('shopify:section:load', (event) => initializeVideoSoundControls(event.target));
  } catch(e) { console.error(e); }
})();

})();
